/* ============================================================
   MAGDA BUTRYM — Tabs + Stock Status + Fixes
   Replace magda-tabs.js in Assets with this file.
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ── Guard: only run on product pages ─────────────────────── */
  var isProductPage = document.querySelector('.product-single') !== null;
  if (!isProductPage) return;

  /* ── 1. CONVERT ACCORDIONS → HORIZONTAL TABS ──────────────── */
  var metas = document.querySelector('.product-single__metas');
  if (metas) {
    var accordions = metas.querySelectorAll('.product-more-info.accordion');
    if (accordions.length > 0) {
      var tabs = [];
      accordions.forEach(function(acc) {
        var titleEl  = acc.querySelector('.collapse_title span');
        var contentEl = acc.querySelector('.panel-collapse');
        if (titleEl && contentEl) {
          tabs.push({ title: titleEl.textContent.trim(), content: contentEl, accordion: acc });
        }
      });

      if (tabs.length > 0) {
        var nav = document.createElement('div');
        nav.className = 'magda-tabs-nav';

        tabs.forEach(function(tab, i) {
          var btn = document.createElement('button');
          btn.textContent = tab.title;
          btn.setAttribute('data-tab-index', i);
          if (i === 0) btn.className = 'active';
          nav.appendChild(btn);
        });

        accordions[0].parentNode.insertBefore(nav, accordions[0]);
        tabs[0].content.classList.add('magda-active');

        nav.addEventListener('click', function(e) {
          if (e.target.tagName !== 'BUTTON') return;
          var index = parseInt(e.target.getAttribute('data-tab-index'));
          nav.querySelectorAll('button').forEach(function(btn) { btn.classList.remove('active'); });
          e.target.classList.add('active');
          tabs.forEach(function(tab, i) {
            tab.content.classList.toggle('magda-active', i === index);
          });
        });
      }
    }
  }

  /* ── 2. STOCK STATUS LABEL + ESTIMATED DELIVERY ────────────── 
     Requires in theme.liquid before magda-tabs.js:
       window.marmarTemplate    = {{ request.template.name | json }};
       window.marmarCollections = {{ product.collections | map: 'handle' | json }};
       window.marmarStockQtys   = {{ product.variants | map: 'inventory_quantity' | json }};

     COLLECTION RULES:
       Any variant qty > 0          → In-Stock        | delivery: unchanged
       Collection: fall-winter-*    → Made-To-Order   | delivery: 4 to 6 weeks
       Collection: pre-fall-*       → Pre-Order        | delivery: unchanged
       Collection: pre-order        → Pre-Order        | delivery: unchanged
       Collection: r27              → Pre-Order        | delivery: 6 to 8 weeks
       Collection: ss27             → Pre-Order        | delivery: unchanged
       Everything else              → Made-To-Order   | delivery: unchanged
  */

  /* Shared: collection handles string used throughout */
  var collections = (window.marmarCollections || []).join(' ').toLowerCase();

  var priceContainer = document.querySelector('.product-single .product-price') ||
                       document.querySelector('.product-single .price-container');

  if (priceContainer) {

    /* ── Identify collection type ── */
    var hasPhysicalStock = (window.marmarStockQtys || []).some(function(qty) { return qty > 0; });

    var isFallWinter = collections.indexOf('fall-winter') > -1 ||
                       collections.indexOf('fall_winter') > -1;

    var isPreFall    = collections.indexOf('pre-fall') > -1 ||
                       collections.indexOf('pre_fall') > -1;

    var isPreOrder   = collections.indexOf('pre-order') > -1 ||
                       collections.indexOf('pre_order') > -1;

    var isR27        = collections.indexOf('r27') > -1;

    var isSS27       = collections.indexOf('ss27') > -1;

    /* ── Determine status label ── */
    var statusText  = null;
    var statusClass = null;

    if (hasPhysicalStock) {
      statusText  = 'In-Stock';
      statusClass = 'in-stock';
    } else if (isR27) {
      statusText  = 'Pre-Order';
      statusClass = 'pre-order';
    } else if (isSS27 || isPreFall || isPreOrder) {
      statusText  = 'Pre-Order';
      statusClass = 'pre-order';
    } else if (isFallWinter) {
      statusText  = 'Made-To-Order';
      statusClass = 'made-to-order';
    } else {
      statusText  = 'Made-To-Order';
      statusClass = 'made-to-order';
    }

    if (statusText) {
      var statusDiv = document.createElement('div');
      statusDiv.className = 'magda-stock-status ' + statusClass;
      statusDiv.textContent = statusText;
      priceContainer.parentNode.insertBefore(statusDiv, priceContainer.nextSibling);
    }
  }

  /* ── 3. HIDE DUPLICATE OPTIONS ROW (single-value variants) ─── */
  var variantWrappers = document.querySelectorAll('.product-single .variants-wrapper');
  variantWrappers.forEach(function(wrapper) {
    var options = wrapper.querySelectorAll('.single-option-selector');
    if (options.length <= 1) {
      var children = wrapper.children;
      for (var i = 0; i < children.length; i++) {
        if (!children[i].classList.contains('variants__label')) {
          children[i].style.display = 'none';
        }
      }
      wrapper.style.marginBottom = '10px';
    }
  });

  /* ── 4. DISABLE IMAGE LIGHTBOX/POPUP ─────────────────────── */
  var popupLinks = document.querySelectorAll(
    '.product-single .bwp-single-image a[data-fancybox],' +
    '.product-single .bwp-single-image [data-popup],' +
    '.product-single .bwp-single-image a[href*="cdn.shopify"]'
  );
  popupLinks.forEach(function(el) {
    el.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); }, true);
    el.style.cursor = 'default';
    el.removeAttribute('data-fancybox');
  });

  /* ── 5. KILL LAZY LOAD BACKGROUND COLOR ──────────────────── */
  function killBgColors() {
    var els = document.querySelectorAll(
      '.product-single .bwp-single-image [style],' +
      '.product-single .bwp-single-image .product-single__media-image,' +
      '.product-single .bwp-single-image .img-wrapper,' +
      '.product-single .bwp-single-image .image-wrap,' +
      '.product-single .bwp-single-image .main_media-content > *,' +
      '.product-single .bwp-single-image .slick-slide > *,' +
      '.product-single .bwp-single-image .slick-slide,' +
      '.product-single .bwp-single-image .media-item,' +
      '.product-single .bwp-single-image .product-featured-media'
    );
    els.forEach(function(el) {
      el.style.setProperty('background-color', 'transparent', 'important');
      el.style.setProperty('background', 'transparent', 'important');
    });
  }
  killBgColors();
  setTimeout(killBgColors, 500);
  setTimeout(killBgColors, 1500);
  setTimeout(killBgColors, 3000);

  /* ── 6. ESTIMATED DELIVERY OVERRIDE ──────────────────────────
     Calculates a date range from today:
     fall-winter  → today + 4 weeks  to  today + 6 weeks
     r27          → today + 6 weeks  to  today + 8 weeks
     ss27         → fixed dates: Jan 25 – Jan 31, 2027 (see SS27_DELIVERY_FROM / _TO)
  */

  /* Fixed delivery window for ss27 — edit these dates (year, month 1-12, day) */
  var SS27_DELIVERY_FROM = [2027, 1, 25];
  var SS27_DELIVERY_TO   = [2027, 1, 31];


  function calcDeliveryHTML(weeksFrom, weeksTo) {
    var days  = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var now  = new Date();
    var from = weeksFrom instanceof Date ? weeksFrom : new Date(now.getTime() + weeksFrom * 7 * 24 * 60 * 60 * 1000);
    var to   = weeksTo   instanceof Date ? weeksTo   : new Date(now.getTime() + weeksTo   * 7 * 24 * 60 * 60 * 1000);

    /* Countdown to midnight */
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    var diff = midnight - now;
    var hoursLeft   = Math.floor(diff / (1000 * 60 * 60));
    var minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    var fromStr = days[from.getDay()] + ', ' + months[from.getMonth()] + ' ' + from.getDate();
    var toStr   = days[to.getDay()]   + ', ' + months[to.getMonth()]   + ' ' + to.getDate();

    return 'Order in the next <strong>' + hoursLeft + ' hours ' + minutesLeft + ' minutes</strong>'
         + ' to get it between <strong><u>' + fromStr + '</u></strong>'
         + ' and <strong><u>' + toStr + '</u></strong>';
  }

  var deliveryHTML = null;

  if (collections.indexOf('ss27') > -1) {
    deliveryHTML = calcDeliveryHTML(
      new Date(SS27_DELIVERY_FROM[0], SS27_DELIVERY_FROM[1] - 1, SS27_DELIVERY_FROM[2]),
      new Date(SS27_DELIVERY_TO[0],   SS27_DELIVERY_TO[1]   - 1, SS27_DELIVERY_TO[2])
    );
  } else if (collections.indexOf('fall-winter') > -1 || collections.indexOf('fall_winter') > -1) {
    deliveryHTML = calcDeliveryHTML(4, 6);
  } else if (collections.indexOf('r27') > -1) {
    deliveryHTML = calcDeliveryHTML(6, 8);
  }

  if (deliveryHTML) {
    function overrideDelivery() {
      var deliveryEl = document.querySelector('.product-single .estimated_delivery') ||
                       document.querySelector('.product-single .section-estimated_delivery .estimated_delivery') ||
                       document.querySelector('.product-single [class*="estimated_delivery"]');

      if (!deliveryEl) return;

      var iconEl = deliveryEl.querySelector('.icons');

      if (iconEl) {
        /* Keep icon, replace rest with our HTML */
        var iconClone = iconEl.cloneNode(true);
        deliveryEl.innerHTML = '';
        deliveryEl.appendChild(iconClone);
        var textSpan = document.createElement('span');
        textSpan.innerHTML = deliveryHTML;
        deliveryEl.appendChild(textSpan);
      } else {
        deliveryEl.innerHTML = deliveryHTML;
      }
    }

    overrideDelivery();
    setTimeout(overrideDelivery, 800);
    setTimeout(overrideDelivery, 2000);
  }

  /* ── 7. REMOVE CLOSE-STICKY DIVIDER ─────────────────────── */
  var closeStickyEl = document.querySelector('.product-single .close-sticky');
  if (closeStickyEl) closeStickyEl.remove();

});

/* ============================================================
   DELIVERY CONFIRMATION IN CART
   1. Product page: on Add to Cart, save the delivery dates shown
      on the page as a hidden line item property (_Estimated delivery).
      Hidden from the storefront, visible on the order in Shopify admin.
   2. Cart drawer / cart page: under the terms & conditions checkbox,
      show the delivery window(s) taken from those properties.
   ============================================================ */
(function() {
  var PROP_NAME = '_Estimated delivery';
  var SEP = ' – ';

  /* ── 1. Product page: read the dates currently shown ── */
  function readDeliveryRange() {
    var el = document.querySelector('.product-single .estimated_delivery');
    if (!el) return null;
    var start = el.querySelector('.day_start');
    var stop  = el.querySelector('.day_stop');
    var from  = start && start.textContent.trim();
    var to    = stop && stop.textContent.trim();
    if (!from || !to) {
      /* Dates written by the collection override above (<u>from</u> … <u>to</u>) */
      var u = el.querySelectorAll('u');
      if (u.length >= 2) {
        from = u[0].textContent.trim();
        to   = u[1].textContent.trim();
      }
    }
    return (from && to) ? from + SEP + to : null;
  }

  function syncDeliveryInput(form) {
    if (!form || !form.closest('.product-single')) return;
    var input = form.querySelector('input[data-delivery-prop]');
    var range = readDeliveryRange();
    if (!range) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + PROP_NAME + ']';
      input.setAttribute('data-delivery-prop', '');
      form.appendChild(input);
    }
    input.value = range;
  }

  /* Capture phase so the value is set before the theme's AJAX add reads the form */
  function onAddToCart(e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (form) syncDeliveryInput(form);
  }
  document.addEventListener('click', onAddToCart, true);
  document.addEventListener('submit', onAddToCart, true);

  /* ── 2. Cart: show the dates under the terms checkbox ── */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function buildNote(items) {
    var lines = [];
    var seen = {};
    items.forEach(function(item) {
      var range = item.properties && item.properties[PROP_NAME];
      if (!range || seen[item.product_title + range]) return;
      seen[item.product_title + range] = true;
      var parts = String(range).split(SEP);
      if (parts.length !== 2) return;
      lines.push({ title: item.product_title, from: parts[0], to: parts[1] });
    });
    if (!lines.length) return '';

    var ranges = lines.map(function(l) { return l.from + SEP + l.to; });
    var allSame = ranges.every(function(r) { return r === ranges[0]; });

    if (allSame) {
      return 'I understand that the estimated delivery time is between <strong>' +
        escapeHtml(lines[0].from) + '</strong> and <strong>' + escapeHtml(lines[0].to) + '</strong>.';
    }
    return 'I understand that the estimated delivery times are:<ul>' +
      lines.map(function(l) {
        return '<li>' + escapeHtml(l.title) + ': between <strong>' + escapeHtml(l.from) +
          '</strong> and <strong>' + escapeHtml(l.to) + '</strong></li>';
      }).join('') + '</ul>';
  }

  /* The theme fixes the drawer footer height when it renders (drawerFooter in wpbingo.js),
     before the note is added — re-measure so the buttons stay visible */
  function refitDrawerFooter(t) {
    var footer = t.closest('.ajaxcart__footer');
    if (!footer || !footer.style.height) return;
    footer.style.height = '';
    var h = footer.offsetHeight;
    footer.style.height = h + 'px';
    var inner = document.querySelector('.ajaxcart__inner');
    if (inner) inner.style.bottom = h + 'px';
  }

  var pending = null;
  function renderNotes() {
    var targets = Array.prototype.filter.call(
      document.querySelectorAll('.ajaxcart_terms_conditions'),
      function(t) { return !t.hasAttribute('data-delivery-checked'); }
    );
    if (!targets.length) return;
    targets.forEach(function(t) { t.setAttribute('data-delivery-checked', ''); });

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var html = buildNote(cart.items || []);
        targets.forEach(function(t) {
          var next = t.nextElementSibling;
          if (next && next.classList.contains('delivery-confirm-note')) next.remove();
          if (html && document.body.contains(t)) {
            var note = document.createElement('div');
            note.className = 'delivery-confirm-note';
            note.innerHTML = html;
            t.parentNode.insertBefore(note, t.nextSibling);
          }
          refitDrawerFooter(t);
        });
      })
      .catch(function(e) { console.error(e); });
  }

  function scheduleRender() {
    clearTimeout(pending);
    pending = setTimeout(renderNotes, 200);
  }

  /* The cart drawer is re-rendered by the theme on every change — watch for it */
  function start() {
    var style = document.createElement('style');
    style.textContent =
      '.delivery-confirm-note{font-size:13px;line-height:1.5;color:#777;margin:-4px 0 15px;padding:0 30px;}' +
      '.delivery-confirm-note strong{color:#000;font-weight:500;}' +
      '.delivery-confirm-note ul{margin:4px 0 0;padding-left:18px;list-style:disc;max-height:72px;overflow-y:auto;}';
    document.head.appendChild(style);
    new MutationObserver(scheduleRender).observe(document.body, { childList: true, subtree: true });
    scheduleRender();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
